import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

// Class to manage a menu in an element to have an identifier and detect when an element is triggered.
export class ThreeDotMenuElement {
    constructor(
        public menu: Array<ThreeDotsMenuItem>,
        public id: string = Math.random().toString(36).replace('0.', '') // Unique identifier
      ) {}


    setTriggered(key: string, state: boolean): void {
        this.menu = this.menu.map(item => {
            if (item.key === key) {
                return { ...item, triggered: state };
            }
            return item;
        });
    }

    isTriggered(key?: string): boolean{
        if (key) {
            const menuItem = this.menu.find(item => item.key === key);
            return menuItem ? menuItem.triggered : false;
        } else {
            return this.menu.some(item => item.triggered);
        }
    }
}
